// #207: Suchregel der Nutzer-Auswahlen (SearchSelect). Strenger Gegenpol bleibt matchesQuery
// (row-filter.ts) für Katalog-/Tabellensuchen — dort soll ein Tippfehler NICHT treffen, weil die
// Treffermengen groß sind. Bei Personen ist die Liste kurz und der Name oft nur gehört, nie gelesen.

/** Kleinschreibung, ohne Akzente, ß → ss: „Jörg Müller“ und „jorg muller“ werden gleich. */
function normalize(s: string): string {
  return s.normalize('NFD').replace(/\p{M}/gu, '').replace(/ß/g, 'ss').toLowerCase();
}

/** Ab dieser Länge darf ein Suchwort einen Tippfehler haben — darunter trifft sonst fast alles. */
const FUZZY_MIN_LENGTH = 4;

/** Editierdistanz mit Vertauschung benachbarter Zeichen (Optimal String Alignment). */
function distance(a: string, b: string): number {
  const w = b.length + 1;
  // Flache Tabelle (i * w + j); at() liefert für nie gelesene Ränder 0 statt undefined.
  const d = new Array<number>((a.length + 1) * w).fill(0);
  const at = (i: number, j: number): number => d[i * w + j] ?? 0;
  for (let i = 0; i <= a.length; i++) d[i * w] = i;
  for (let j = 0; j <= b.length; j++) d[j] = j;
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      let v = Math.min(at(i - 1, j) + 1, at(i, j - 1) + 1, at(i - 1, j - 1) + cost);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
        v = Math.min(v, at(i - 2, j - 2) + 1);
      }
      d[i * w + j] = v;
    }
  }
  return at(a.length, b.length);
}

/** Passt das Suchwort auf den Anfang eines Wortes, mit höchstens einem Fehler? Verglichen wird
 *  mit Wortanfängen ±1 Zeichen um die Suchwortlänge, damit fehlende/doppelte Zeichen zählen. */
function nearPrefix(token: string, word: string): boolean {
  for (let len = token.length - 1; len <= token.length + 1; len++) {
    if (len <= 0 || len > word.length) continue;
    if (distance(token, word.slice(0, len)) <= 1) return true;
  }
  return false;
}

/**
 * Trifft die Suche auf den Namen (und weitere Felder, z. B. E-Mail)? Jedes Suchwort muss passen,
 * Reihenfolge egal: als Teilstück irgendwo, oder ab vier Zeichen mit einem Tippfehler am
 * Wortanfang.
 */
export function matchesName(query: string, ...fields: (string | null | undefined)[]): boolean {
  const tokens = normalize(query).split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;
  const haystack = normalize(fields.filter(Boolean).join(' '));
  const words = haystack.split(/[^\p{L}\p{N}]+/u).filter(Boolean);
  return tokens.every(
    (token) =>
      haystack.includes(token) ||
      (token.length >= FUZZY_MIN_LENGTH && words.some((w) => nearPrefix(token, w))),
  );
}
